import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";

export default function NotFound() {
  return (
    <Layout>
      <div className="mx-auto flex max-w-[1280px] flex-col items-center justify-center px-4 py-24 text-center md:px-6">
        <p className="font-display text-7xl text-primary-500 md:text-9xl">404</p>
        <h1 className="mt-4 text-2xl font-bold text-foreground-950 md:text-3xl">页面走丢了</h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          你要访问的页面不存在或已被移除。不妨返回首页，看看最新的动画推荐与动漫资讯。
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/category/recommend"
            className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            浏览动画推荐
          </Link>
        </div>
      </div>
    </Layout>
  );
}